import { NOT_DESKTOP_RESOLUTION, getCurrentResolution } from './resizeObserver';

export const isNotDesktop = () => getCurrentResolution() === NOT_DESKTOP_RESOLUTION;
